/**
 * 事项追踪模块
 * **/
import {queryTaskTrackingByUserId} from '@/assets/js/api';

export default {
  state: {
    // 事项追踪总览
    // SMS(1, "短信"),
    // VOICE_CALL(2, "外呼"),
    // MAKE_WRIT(4, "制作文书"),
    // UPLOAD_WRIT(5, "上传文书"),
    // SIGNATURE(6, "发起签字"),
    // DELIVERY_DOC(7, "文书送达"),
    // RESERVE_VIDEO_MEDIATION(8, "预约视频调解"),
    // REPAY_PLAN_CONFIRM(10, "还款方案确认"),
    // REPAY_PLAN_GENERAL(11, "还款计划生成"),
    // REPAY_PLAN_REGIST(12, "还款记录登记"),
    // PACK_LOAD_DOCS(23,"文书下载追踪")
    eventTrack: [
      {
        name: '短信发送追踪',
        value: 0,
        suffix: '个',
        taskType: 1,
        powerCode: 'mdtorSendSms'
      },
      {
        name: '外呼事项追踪',
        value: 0,
        suffix: '个',
        taskType: 2,
        powerCode: 'mdtorOutCall'
      },
      {
        name: '还款记录登记',
        value: 0,
        suffix: '个',
        taskType: 12
      },
      {
        name: '文书签字追踪',
        value: 0,
        suffix: '个',
        taskType: 6,
        powerCode: 'mdtorOnlineSign'
      },
      {
        name: '文书下载追踪',
        value: 0,
        suffix: '个',
        taskType: 23
      },
      {
        name: '文书送达追踪',
        value: 0,
        suffix: '个',
        taskType: 7
      },
      {
        name: '电子签章事项追踪',
        value: 0,
        suffix: '个',
        taskType: 24,
        powerCode: 'mdtorBatchSeal'
      },
      {
        name: '文书生成追踪',
        value: 0,
        suffix: '个',
        taskType: 25,
        powerCode: 'mdtorGenDoc'
      },
      {
        name: '自助签约追踪',
        value: 0,
        suffix: '个',
        taskType: 26,
        powerCode: 'mdtorSelfSign'
      }
    ]
  },
  mutations: {
    QUERY_TASK_TRACKING_BY_USERID: (state, _data) => {
      state.eventTrack.forEach((item) => {
        const taskType = item.taskType;
        for (let i = 0; i < _data.length; i++) {
          if (taskType === Number(_data[i].taskType)) {
            item.value = _data[i].taskCount;
            break;
          }
        }
      });
    }
  },
  actions: {
    // 获取各个事项追踪数量
    QueryTaskTrackingByUserId({commit}, _data) {
      queryTaskTrackingByUserId(_data).then(res => {
        if (res.code === 200) {
          commit('QUERY_TASK_TRACKING_BY_USERID', res.data);
        }
      });
    }
  }
};
